<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<h2 class="h2c">Contents</h2>
<p class="toc-fmta"><a href="#/xhtml/preface#pre01" id="pre01">Preface</a></p>
<p class="toc-fmta"><a href="#/xhtml/introduction#intro" id="intro">Introduction: Civilization in Disarray</a></p>
<p class="toc-chap"><a href="#/xhtml/chapter01#ch-1" id="ch1"><span class="sans"><b>1</b></span>   The Quintessential Victims of War</a></p>
<p class="toc-chap"><span href="#/xhtml/chapter02#ch-2" id="ch2" title="Link target outside of Sample"><span class="sans"><b>2</b></span>   Saving the Children</span></p>
<p class="toc-chap"><span href="#/xhtml/chapter03#ch-3" id="ch3" title="Link target outside of Sample"><span class="sans"><b>3</b></span>   A “Psychological Marshall Plan”</span></p>
<p class="toc-chap"><span href="#/xhtml/chapter04#ch-4" id="ch4" title="Link target outside of Sample"><span class="sans"><b>4</b></span>   Renationalizing Displaced Children</span></p>
<p class="toc-chap"><span href="#/xhtml/chapter05#ch-5" id="ch5" title="Link target outside of Sample"><span class="sans"><b>5</b></span>   Children as Spoils of War in France</span></p>
<p class="toc-chap"><span href="#/xhtml/chapter06#ch-6" id="ch6" title="Link target outside of Sample"><span class="sans"><b>6</b></span>   Ethnic Cleansing and the Family in Czechoslovakia</span></p>
<p class="toc-chap"><span href="#/xhtml/chapter07#ch-7" id="ch7" title="Link target outside of Sample"><span class="sans"><b>7</b></span>   Repatriation and the Cold War</span></p>
<p class="toc-chap1"><span href="#/xhtml/chapter08#ch-8" id="ch8" title="Link target outside of Sample"><span class="sans"><b>8</b></span>   From Divided Families to a Divided Europe</span></p>
<p class="toc-fmta1"><span href="#/xhtml/archival#arc" id="arc" title="Link target outside of Sample">Archival Sources and Abbreviations</span></p>
<p class="toc-fmta"><span href="#/xhtml/notes#note" id="note" title="Link target outside of Sample">Notes</span></p>
<p class="toc-fmta"><span href="#/xhtml/index#ind" id="ind" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?6fde9d98